var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsync2 } from "nate-react-api-helpers";
import { useRef } from "react";
export function useGetAll(input, props, propDeps, hint) { const lastCtx = useRef({ cancelled: false }); return useAsync2(props => { lastCtx.current.cancelled = true; const ctx = { cancelled: false }; lastCtx.current = ctx; return getAll(ctx, offset => input(Object.assign({}, props, { offset: offset })), hint); }, props, propDeps); }
export function getAll(ctx, method, hint) {
    return __awaiter(this, void 0, void 0, function* () {
        let data = []; // sorted by offset
        let expectedCount = 0;
        let chunkSize = 0; // assume to start
        let claimedOffsets = [];
        let cancelled = false; // parallelize
        const maxParallel = 3;
        let parallel = 0;
        const get = offset => { if (claimedOffsets.includes(offset))
            return Promise.resolve(); claimedOffsets.push(offset); while (data.length < offset) {
            data.push(undefined);
        } return method(offset).then(r => { if (cancelled || ctx !== null && ctx !== void 0 && ctx.cancelled)
            return; r.data.map((r, index) => { if (data.length === offset + index) {
            data.push(r);
        }
        else {
            data[offset + index] = r;
        } }); while (data.length < r.count) {
            data.push(undefined);
        } expectedCount = r.count; if (r.data.length > chunkSize) {
            chunkSize = r.data.length;
        } }); };
        const availableOffsets = () => {
            let offsets = [];
            let baseIndex = 0;
            const parallelOpts = Math.min(2, maxParallel - parallel + 1); // grow by 1 parallel per iteration if available
            while (offsets.length < parallelOpts) { // null entries mean that data is missing for that chunk
                const i = data.indexOf(undefined, baseIndex);
                if (i >= expectedCount)
                    return offsets; // no more data to fetch
                if (i === -1) {
                    if (expectedCount > 0)
                        return offsets; // no more data to fetch, have the end and no nulls
                    if (chunkSize === 0)
                        return offsets; // don't have enough information to start parallel fetches, if offset=0 request finds data it will multiply workers
                    let offset = data.length;
                    while (offsets.length < parallelOpts) {
                        if (!claimedOffsets.includes(offset)) {
                            offsets.push(offset);
                        }
                        offset += chunkSize;
                    }
                    return offsets;
                }
                if (!claimedOffsets.includes(i)) {
                    offsets.push(i);
                }
                if (chunkSize === 0)
                    return offsets; // don't have enough information to start parallel fetches, if offset=0 request finds data it will multiply workers
                baseIndex = i + chunkSize;
                if (expectedCount > 0 && baseIndex >= data.length) {
                    return offsets;
                }
            }
            return offsets;
        };
        const worker = (startOffset) => __awaiter(this, void 0, void 0, function* () {
            if (parallel + 1 > maxParallel)
                return;
            parallel++; // prevent duplicate fetches
            if (claimedOffsets.includes(startOffset))
                return;
            yield get(startOffset);
            if (cancelled || ctx !== null && ctx !== void 0 && ctx.cancelled)
                return;
            for (let i = 0; i < 100; i++) {
                const offsets = availableOffsets();
                if (offsets.length === 0)
                    return;
                let todo = [];
                for (let j = 0; j < offsets.length; j++) {
                    if (j === 0) {
                        todo.push(get(offsets[j]));
                    }
                    else {
                        todo.push(worker(offsets[j]));
                    }
                }
                yield Promise.all(todo);
                if (cancelled || ctx !== null && ctx !== void 0 && ctx.cancelled)
                    return;
            }
        });
        const lazy = !!(hint !== null && hint !== void 0 && hint.useLazy); // get starting point to check data layout before starting too many parallel
        let workers = [];
        workers.push(worker(0));
        const targetSize = 250;
        if (!lazy) {
            workers.push(worker(targetSize));
            workers.push(worker(targetSize * 2));
        }
        try {
            yield Promise.all(workers);
        }
        finally {
            cancelled = true;
        }
        return data.filter(v => v !== undefined);
    });
}
